import React from 'react'

const ConfigurationMissing: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '16px'
        }}>
          🔧
        </div>
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#333'
        }}>
          Configuration Required
        </h1>
        
        <p style={{
          color: '#666',
          marginBottom: '24px',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          Supabase environment variables are missing. Please set up your configuration to enable authentication.
        </p>

        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #e1e5e9',
          textAlign: 'left',
          marginBottom: '24px'
        }}>
          <h3 style={{
            margin: '0 0 12px 0',
            fontSize: '16px',
            fontWeight: '600'
          }}>
            Required Environment Variables:
          </h3>
          <div style={{
            fontFamily: 'Monaco, Consolas, monospace',
            fontSize: '14px',
            color: '#333'
          }}>
            <div>REACT_APP_SUPABASE_URL</div>
            <div>REACT_APP_SUPABASE_ANON_KEY</div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#fff3cd',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid #ffeaa7',
          marginBottom: '24px'
        }}>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#856404',
            lineHeight: '1.4'
          }}>
            <strong>Quick Fix:</strong> Add these variables to your <code>.env</code> file in the <code>agent_chat_server/</code> directory and restart the development server.
          </p>
        </div>

        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#0056b3'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#007bff'
          }}
        >
          Reload After Configuration
        </button>

        <p style={{
          fontSize: '12px',
          color: '#999',
          marginTop: '20px',
          lineHeight: '1.4'
        }}>
          Check the browser console for more detailed error messages.
        </p>
      </div>
    </div>
  )
}

export default ConfigurationMissing 